import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DaySequence, DaySequenceStatus, Job } from '@core/generated/gql-types';
import { useDaySequenceStore } from '@core/daySequence/useDaySequenceStore';
import TimesheetsToAction from './TimesheetsToAction';
import { actionLinkClassName } from '@core/theme/actionTheme.util';

interface TimesheetsToActionSectionProps {
  job: Job;
}

const TimesheetsToActionSection = ({ job }: TimesheetsToActionSectionProps) => {
  const [actionRequiredDaySequences, setActionRequiredDaySequences] = useState<
    DaySequence[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDaySequences = useCallback(async () => {
    if (!job?.id) {
      setActionRequiredDaySequences([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const allDaySequences = useDaySequenceStore
      .getState()
      .getDaySequenceByJobId(job.id);

    setActionRequiredDaySequences(
      allDaySequences.filter(
        (daySequence) =>
          daySequence.status === DaySequenceStatus.EscalatedToTenant,
      ),
    );

    setIsLoading(false);
  }, [job?.id]);

  useEffect(() => {
    fetchDaySequences();
  }, [fetchDaySequences]);

  // Only show timesheets section if the job has a user assigned.
  if (!job.userId) {
    return <></>;
  }

  return (
    <>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">
          Timesheets to action
        </h3>
        <Link
          to={`/jobs/${job.id}?tab=timesheets`}
          className={`flex cursor-pointer items-center text-sm font-medium ${actionLinkClassName}`}
        >
          View all
        </Link>
      </div>

      <TimesheetsToAction
        job={job}
        actionRequiredDaySequences={actionRequiredDaySequences}
        fetchDaySequences={fetchDaySequences}
        loading={isLoading}
      />
    </>
  );
};

export default TimesheetsToActionSection;
